// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2iHDs","productName":"Table_productName__2UfAZ"};